<template>
    <td class="border-b border-r first-of-type:border-l  border-gray-300 text-xs align-top overflow-hidden w-full">
      <slot></slot>
    </td>
</template>
  